import React, { useState } from "react";

export default function QuizFaqs() {
  const faqs = [
    {
      question: "How do I reset my password?",
      answer:
        "Click ‘Forgot Password’ on the login page and follow the instructions. You’ll receive an email with a reset link within minutes.",
    },
    {
      question: "Are practice quizzes really free?",
      answer:
        "Yes. All practice quizzes are free with no hidden charges. You can access unlimited sessions anytime.",
    },
    {
      question: "How are prizes distributed?",
      answer:
        "Prizes are distributed within 7 working days via bank transfer or digital wallet. Winners are notified via email and SMS.",
    },
    {
      question: "Can schools register multiple students?",
      answer:
        "Yes, schools can use our bulk registration feature to add multiple students. Contact support if you need assistance.",
    },
  ];

  const [showFaq, setShowFaq] = useState(false);
  const [openIdx, setOpenIdx] = useState(null);

  const toggleIdx = (idx) => {
    setOpenIdx((prev) => (prev === idx ? null : idx));
  };

  const closeFaq = () => {
    setShowFaq(false);
    setOpenIdx(null);
  };

  return (
    <>
      {/* FAQ Floating Icon */}
      <button
        type="button"
        title="Frequently Asked Questions"
        onClick={() => setShowFaq(true)}
        style={{
          position: "fixed",
          right: "25px",
          bottom: "25px",
          width: "52px",
          height: "52px",
          borderRadius: "50%",
          border: "none",
          background: "#2563eb",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "23px",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
          zIndex: 999,
        }}
      >
        <i className="bi bi-question-circle-fill"></i>
      </button>

      {/* FAQ Popup */}
      {showFaq && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            zIndex: 1000,
          }}
          onClick={closeFaq}
        >
          {/* Popup Content */}
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "650px",
              maxHeight: "80vh",
              overflowY: "auto",
              borderRadius: "12px",
              padding: "25px",
              position: "relative",
              boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Popup Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "15px",
              }}
            >
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontWeight: "600",
                  }}
                >
                  Frequently Asked Questions
                </h4>

                <p
                  style={{
                    margin: "5px 0 0",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  Quick answers to common questions
                </p>
              </div>

              {/* Close Button */}
              <button
                type="button"
                title="Close"
                onClick={closeFaq}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#555",
                  padding: "2px 5px",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            {/* FAQ List */}
            <div className="faq-list">
              {faqs.map((faq, i) => {
                const open = openIdx === i;
                const qId = `faq-q-${i}`;
                const aId = `faq-a-${i}`;

                return (
                  <div
                    key={i}
                    className={`faq-item ${open ? "active" : ""}`}
                    style={{
                      borderBottom: "1px solid #e5e5e5",
                      padding: "12px 0",
                    }}
                  >
                    {/* Question */}
                    <button
                      type="button"
                      id={qId}
                      aria-expanded={open}
                      aria-controls={aId}
                      onClick={() => toggleIdx(i)}
                      style={{
                        width: "100%",
                        border: "none",
                        background: "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textAlign: "left",
                        cursor: "pointer",
                        padding: "5px 0",
                        fontSize: "15px",
                        fontWeight: "600",
                        color: "#222",
                      }}
                    >
                      <span>{faq.question}</span>

                      <span
                        style={{
                          marginLeft: "15px",
                          minWidth: "24px",
                          textAlign: "center",
                          color: "#2563eb",
                        }}
                      >
                        <i
                          className={`bi ${open ? "bi-dash-lg" : "bi-plus-lg"}`}
                        ></i>
                      </span>
                    </button>

                    {/* Answer */}
                    {open && (
                      <div
                        id={aId}
                        role="region"
                        aria-labelledby={qId}
                        style={{
                          padding: "10px 30px 5px 0",
                          color: "#666",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        {faq.answer}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
